// 📁 utils/categoriaHelpers.js - SIN IMPORTS DE ICONOS
// IMPORTAR las funciones que faltan desde representanteUtils
import { 
  obtenerCargoJunta, 
  romanToInt, 
  extraerNumeroRomano 
} from './representanteUtils';

// Obtener tipo de icono (retorna string, no componente)
export const getCategoriaIconType = (descripcion) => {
  switch (descripcion?.toUpperCase()) {
    case "FCN": 
    case "REPRESENTANTES ANTE LA JUNTA DE FCN":
      return "AccountBalance";
    case "DEPARTAMENTAL": 
      return "LocationOn";
    case "MUNICIPAL": 
      return "LocationOn";
    case "JUNTA DIRECTIVA": 
      return "Groups";
    case "GUBERNAMENTAL": 
      return "AccountBalance";
    default: 
      return "Category";
  }
};

// Función para obtener nombre de categoría personalizado
export const getNombreCategoriaPersonalizado = (categoria) => {
  if (!categoria) return '';
  
  // Cambiar "FCN" por texto más descriptivo
  if (categoria.Descripcion?.toUpperCase() === 'FCN') {
    return 'Representantes ante la Junta de FCN';
  }
  
  // Para otras categorías, devolver el nombre original
  return categoria.Descripcion;
};

// Obtener nombre de departamento
export const getNombreDepartamento = (departamentos, cod_depto) => {
  const depto = departamentos?.find((d) => d.CodigoDepartamento === cod_depto);
  return depto ? depto.NombreDepartamento : "N/A";
};

// Obtener nombre de municipio
export const getNombreMunicipio = (municipios, cod_municipio) => {
  const municipio = municipios?.find((m) => m.CodigoMunicipio === cod_municipio);
  return municipio ? municipio.NombreMunicipio : "N/A";
};

// Obtener nombre de asociación
export const getNombreAsociacion = (asociaciones, cod_asociacion) => {
  const asociacion = asociaciones?.find((a) => a.cod_asociacion === cod_asociacion);
  return asociacion ? asociacion.nombre_abreviado : "N/A";
};

// Obtener miembros específicos de junta directiva
export const getMiembrosJuntaDirectiva = (representantes, cod_asociacion) => {
  const representantesFiltrados = representantes.filter(rep => 
    rep.cod_asociacion === cod_asociacion
  );

  const presidente = representantesFiltrados.find(rep => {
    const cargo = obtenerCargoJunta(rep).toLowerCase();
    return cargo.includes('presidente') && !cargo.includes('vice');
  });

  const vicepresidente = representantesFiltrados.find(rep => {
    const cargo = obtenerCargoJunta(rep).toLowerCase();
    return cargo.includes('vicepresidente') || cargo.includes('vice');
  });

  const secretario = representantesFiltrados.find(rep => {
    const cargo = obtenerCargoJunta(rep).toLowerCase();
    return cargo.includes('secretario');
  });

  const tesorero = representantesFiltrados.find(rep => {
    const cargo = obtenerCargoJunta(rep).toLowerCase();
    return cargo.includes('tesorero');
  });

  const vocales = representantesFiltrados.filter(rep => {
    const cargo = obtenerCargoJunta(rep).toLowerCase();
    return cargo.includes('vocal');
  }).sort((a, b) => {
    const numeroA = romanToInt(extraerNumeroRomano(obtenerCargoJunta(a)));
    const numeroB = romanToInt(extraerNumeroRomano(obtenerCargoJunta(b)));
    return numeroA - numeroB;
  });

  return {
    presidente,
    vicepresidente,
    secretario,
    tesorero,
    vocales,
    todos: representantesFiltrados
  };
};